import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CheckoutReviewSubmitComponent, CheckoutStepService } from '@spartacus/checkout/base/components';
import {
  CheckoutDeliveryAddressFacade,
  CheckoutDeliveryModesFacade,
  CheckoutPaymentFacade,
} from '@spartacus/checkout/base/root';
import { B2BCheckoutReviewSubmitComponent } from '@spartacus/checkout/b2b/components';
import { ActiveCartService } from '@spartacus/cart/base/core';
import { TranslationService, UserAddressService, UserCostCenterService, TranslatePipe, UrlPipe } from '@spartacus/core';
import { Card, ICON_TYPE, CardComponent, IconComponent, PromotionsComponent } from '@spartacus/storefront';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { KnBrAddress } from 'src/app/models/kn-br-order.model';
import { CheckoutCostCenterFacade, CheckoutPaymentTypeFacade } from '@spartacus/checkout/b2b/root';
import { NgTemplateOutlet, AsyncPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { CartItemListComponent } from '@spartacus/cart/base/components';

@Component({
    selector: 'cx-review-submit',
    templateUrl: './kn-br-review-submit.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgTemplateOutlet, CardComponent, RouterLink, IconComponent, PromotionsComponent, CartItemListComponent, AsyncPipe, TranslatePipe, UrlPipe]
})
export class KnBrReviewSubmitComponent extends B2BCheckoutReviewSubmitComponent {
  countryName$;
  constructor(
    protected checkoutDeliveryModesFacade: CheckoutDeliveryModesFacade,
    protected checkoutDeliveryService: CheckoutDeliveryAddressFacade,
    protected checkoutPaymentService: CheckoutPaymentFacade,
    protected userAddressService: UserAddressService,
    protected activeCartService: ActiveCartService,
    protected translation: TranslationService,
    protected checkoutStepService: CheckoutStepService,
    protected checkoutPaymentTypeFacade: CheckoutPaymentTypeFacade,
    protected checkoutCostCenterFacade: CheckoutCostCenterFacade,
    protected userCostCenterService: UserCostCenterService
  ) {
    super(
      checkoutDeliveryService,
      checkoutPaymentService,
      activeCartService,
      translation,
      checkoutStepService,
      checkoutDeliveryModesFacade,
      checkoutPaymentTypeFacade,
      checkoutCostCenterFacade,
      userCostCenterService
    );
    this.countryName$ = checkoutDeliveryService?.getDeliveryAddressState().pipe(map((res) => res.data.country));
  }

  getShippingAddressCard(deliveryAddress: KnBrAddress, countryName: string): Observable<Card> {
    return combineLatest([this.translation.translate('addressCard.shipTo')]).pipe(
      map(([textTitle]) => {
        if (!countryName) {
          countryName = deliveryAddress?.country?.isocode;
        }

        let region = '';
        if (deliveryAddress && deliveryAddress.region && deliveryAddress.region.isocode) {
          region = deliveryAddress.region.isocode;
        }

        return {
          title: textTitle,
          textBold: deliveryAddress.firstName + (deliveryAddress.lastName ? ' ' + deliveryAddress.lastName : ''),
          text: [
            (deliveryAddress.houseNumber ? deliveryAddress.houseNumber + ', ' : '') + deliveryAddress.line1,
            deliveryAddress.line2,
            deliveryAddress.town + ', ' + region,
            countryName + ', ' + deliveryAddress.postalCode,
            deliveryAddress.phone,
          ],
        };
      })
    );
  }
}
